import "./App.css";
import "./index.css";
import Chat from "./pages/Chat";
import StudyPlan from "./pages/StudyPlan";
import Login from "./pages/Login";
import MyBooks from "./pages/MyBooks";
import Register from "./pages/Register";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import React, { useState, useEffect, useRef, useCallback } from "react";

// AppContent 컴포넌트 생성
const AppContent = () => {
  const navigate = useNavigate();

  // 로그인 상태 localStorage에서 불러오기
  const [nickname, setNickname] = useState(() => {
    return localStorage.getItem("nickname") || "";
  });

  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem("isAuthenticated") === "true";
  });
  const [showStartMenu, setShowStartMenu] = useState(() => {
    return localStorage.getItem("showStartMenu") !== "false";
  });
  // localStorage에서 chat 메시지 불러오기
  const [messages, setMessages] = useState(() => {
    const savedMessages = localStorage.getItem("chatMessages");
    // 초기 메시지 설정
    const initialMessage = {
      id: Date.now(),
      text: `<h3 style="font-family: Pretendard; font-size: 14px; font-weight: 700; line-height: 28.8px; letter-spacing: -0.001em; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;">${nickname} 학생, 공부하기 좋은 아침이네요. 오늘 하루도 좋은 하루가 될 거예요.☀️</h3> <h3 style="font-family: Pretendard; font-size: 14px; font-weight: 700; line-height: 28.8px; letter-spacing: -0.001em; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;">원하는 메뉴를 선택해 주세요!</h3>`,
      isUser: false,
    };

    return savedMessages ? JSON.parse(savedMessages) : [initialMessage];
  });

  // localStorage에서 plan 메시지 불러오기
  const [planMessages, setPlanMessages] = useState(() => {
    const savedPlanMessages = localStorage.getItem("planMessages");
    const initialPlanMessage = {
      id: Date.now(),
      text: `<h3 style="font-family: Pretendard; font-size: 14px; font-weight: 700; line-height: 28.8px; letter-spacing: -0.001em; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;">${nickname} 학생이 고등수학을 끝까지 완독할 수 있도록 학습 플랜을 세워드릴게요! 📚✨ 계획하고 있는 공부 기간을 말씀해주세요! 💭</h3>`,
      isUser: false,
      options: ["1주일", "1개월", "3개월", "6개월"],
      optionSelected: false,
    };
    return savedPlanMessages
      ? JSON.parse(savedPlanMessages)
      : [initialPlanMessage];
  });

  // planMessages가 변경될 때마다 localStorage에 저장하는 useEffect 추가
  useEffect(() => {
    localStorage.setItem("planMessages", JSON.stringify(planMessages));
  }, [planMessages]);

  // nickname이 변경될 때 planMessages 업데이트하는 부분 수정
  useEffect(() => {
    // localStorage에 저장된 planMessages가 없을 때만 초기화
    if (!localStorage.getItem("planMessages")) {
      setPlanMessages([
        {
          id: Date.now(),
          text: `<h3 style="font-family: Pretendard; font-size: 14px; font-weight: 700; line-height: 28.8px; letter-spacing: -0.001em; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;">${nickname} 학생이 고등수학을 끝까지 완독할 수 있도록 학습 플랜을 세워드릴게요! 📚✨ 계획하고 있는 공부 기간을 말씀해주세요! 💭</h3>`,
          isUser: false,
          options: ["1주일", "1개월", "3개월", "6개월"],
          optionSelected: false,
        },
      ]);
    }
  }, [nickname]);

  // messages가 변경될 때마다 localStorage에 저장
  useEffect(() => {
    localStorage.setItem("chatMessages", JSON.stringify(messages));
    // messages가 비어있거나 초기 메시지만 있을 때 showStartMenu를 true로 설정
    if (!messages.length || messages.length === 1) {
      setShowStartMenu(true);
      localStorage.setItem("showStartMenu", "true");
    }
  }, [messages]);

  // showStartMenu 상태가 변경될 때마다 localStorage에 저장
  useEffect(() => {
    localStorage.setItem("showStartMenu", showStartMenu);
  }, [showStartMenu]);

  // 로그인 상태가 변경될 때마다 localStorage에 저장
  useEffect(() => {
    localStorage.setItem("nickname", nickname);
    localStorage.setItem("isAuthenticated", isAuthenticated);
  }, [nickname, isAuthenticated]);

  // 컴포넌트가 마운트될 때 메시지 초기화는 messages가 비어있을 때만
  useEffect(() => {
    if (isAuthenticated && (!messages || messages.length === 0)) {
      const greeting = getGreeting();
      const initialMessage = {
        id: Date.now(),
        text: `<h3 style="font-family: Pretendard; font-size: 14px; font-weight: 700; line-height: 28.8px; letter-spacing: -0.001em; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;">${nickname} 학생, ${greeting}</h3> <h3 style="font-family: Pretendard; font-size: 14px; font-weight: 700; line-height: 28.8px; letter-spacing: -0.001em; text-align: left; text-underline-position: from-font; text-decoration-skip-ink: none;">원하는 메뉴를 선택해 주세요!</h3>`,
        isUser: false,
      };
      setMessages([initialMessage]);
      setShowStartMenu(true);
      localStorage.setItem("chatMessages", JSON.stringify([initialMessage]));
    }
  }, [isAuthenticated, nickname]);

  // 시간에 따른 인사말을 반환하는 함수 추가
  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour >= 22 || hour < 6) {
      return "조용히 집중하기 좋은 시간이에요. 서책 에이전트가 함께 할게요.🌙";
    } else if (hour < 12) {
      return "공부하기 좋은 아침이네요. 오늘 하루도 좋은 하루가 될 거예요.☀️";
    } else if (hour < 18) {
      return "서책 에이전트와 오후 시간도 알차게 보내봐요.💪";
    } else {
      return "저녁 공부도 힘차게 해볼까요? 서책 에이전트가 끝까지 응원할게요.😃";
    }
  };

  // WebSocket 관련 상태 단순화
  const [ws, setWs] = useState(null);
  const [isConnecting, setIsConnecting] = useState(false);

  // WebSocket 연결 함수 단순화
  const connectWebSocket = useCallback(() => {
    if (isConnecting || ws?.readyState === WebSocket.OPEN) return;

    setIsConnecting(true);

    try {
      const websocket = new WebSocket(
        `${process.env.REACT_APP_CHAT_WS_SERVER_URL}/chat/ws`
      );

      websocket.onopen = () => {
        console.log("WebSocket Connected");
        setIsConnecting(false);
        setWs(websocket);
      };

      websocket.onmessage = (event) => {
        const response = JSON.parse(event.data);
        console.log("Received message:", response);
      };

      websocket.onerror = (error) => {
        console.error("WebSocket error:", error);
        setIsConnecting(false);
        if (ws) {
          ws.close();
          setWs(null);
        }
      };

      websocket.onclose = () => {
        console.log("WebSocket Disconnected");
        setIsConnecting(false);
        setWs(null);
      };
    } catch (error) {
      console.error("WebSocket connection error:", error);
      setIsConnecting(false);
    }
  }, [isConnecting, ws]);

  // WebSocket 연결 관리를 위한 useEffect
  useEffect(() => {
    let cleanupFunction = false;

    const initializeWebSocket = () => {
      if (
        !cleanupFunction &&
        isAuthenticated &&
        (!ws || ws.readyState !== WebSocket.OPEN) &&
        !isConnecting
      ) {
        connectWebSocket();
      }
    };

    initializeWebSocket();

    return () => {
      cleanupFunction = true;
      if (ws) {
        ws.close();
        setWs(null);
      }
    };
  }, [isAuthenticated]);

  const handleLogout = useCallback(() => {
    setIsAuthenticated(false);
    setNickname("");
    // WebSocket 연결 종료
    if (ws) {
      ws.close();
    }
    // 로컬 스토리지 클리어
    localStorage.clear();
    // 로그인 페이지로 리다이렉트
    navigate("/login");
  }, [ws, navigate]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          isAuthenticated ? (
            <Navigate to="/chat" replace />
          ) : (
            <Login
              nickname={nickname}
              setNickname={setNickname}
              setIsAuthenticated={setIsAuthenticated}
            />
          )
        }
      />
      <Route
        path="/chat"
        element={
          isAuthenticated ? (
            <Chat
              messages={messages}
              setMessages={setMessages}
              nickname={nickname}
              setNickname={setNickname}
              isAuthenticated={isAuthenticated}
              setIsAuthenticated={setIsAuthenticated}
              showStartMenu={showStartMenu}
              setShowStartMenu={setShowStartMenu}
              ws={ws}
              handleLogout={handleLogout}
            />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/plan"
        element={
          isAuthenticated ? (
            <StudyPlan
              planMessages={planMessages}
              setPlanMessages={setPlanMessages}
              nickname={nickname}
              setNickname={setNickname}
              isAuthenticated={isAuthenticated}
              setIsAuthenticated={setIsAuthenticated}
              initialQuestionPhase={true}
              initialQuestionIndex={-1}
              ws={ws}
              handleLogout={handleLogout}
            />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route
        path="/mybooks"
        element={
          isAuthenticated ? (
            <MyBooks nickname={nickname} handleLogout={handleLogout} />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route path="/register" element={<Register />} />
    </Routes>
  );
};

// App 컴포넌트
function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
